import styled from 'styled-components';

export const Wrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
width: 100%;
gap: 5px;
height: auto;
.label {
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    color: #61788E;
    @media (max-width: 600px) {
        font-size: 13px;
        line-height: 26px;
    }
}
.birth-date {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    width: 100%;
    height: auto;
.column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;     
    gap: 5px;
    width: 140px;
}
.row-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;     
    gap: 5px;
    border: 1px solid #E5E7EB;
    width: 100%;
    border-radius: 10px;
    padding: 0 5px;
    padding-top: 5px;
    cursor: pointer;
    &:hover {
        border: 1px solid gray;
    }
}
.first-input {
    ${p => p.active === '1' && `
        border: 2px solid #3f51b5 !important;
    `}
}
.second-input {
    ${p => p.active === '2' && `
        border: 2px solid #3f51b5 !important;
    `}
}
.third-input {
    ${p => p.active === '3' && `
        border: 2px solid #3f51b5 !important;
    `}
}
.label {
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    color: #61788E;
    @media (max-width: 600px) {
        font-size: 13px;
        line-height: 26px;
    }
}
.value {
    font-size: 16px;
	font-weight: 400;
    color: #0D2439;
	@media (max-width: 600px) {
		fontSize: 15px;
	}
}
}
`